import type { FullAudit, NewAuditRequest } from '~/constants/auditTypes'
import apiUtil, { throwApiError } from '~/utils/apiUtils'
const { get, post, put, del } = apiUtil()

export interface AuditListResponse {
  audits: FullAudit[]
  page: number
  limit: number
  total: number
}

class AuditAPI {
  constructor() {
    this.getAuditList = this.getAuditList.bind(this)
  }

  // POST method to sign up
  async createAudit(newAudit: NewAuditRequest): Promise<FullAudit> {
    try {
      const response = await post('/audit', newAudit)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error creating audit:', error)
      throw error
    }
  }

  async updateAudit(auditId: string, audit: SelectedAudit): Promise<FullAudit> {
    try {
      const newAudit = {
        ...audit,
      }
      const response = await put(`/audit/${auditId}`, newAudit)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error updating audit:', error)
      throw error
    }
  }

  async getAuditList(): Promise<AuditListResponse> {
    try {
      const response = await get('/audit')

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json ?? { audits: [], page: 1, limit: 50, total: 0 }
    } catch (error) {
      console.error('Error getting audit list:', error)
      throw error
    }
  }

  async getAudit(auditId: string): Promise<FullAudit> {
    try {
      const response = await get(`/audit/${auditId}`)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error getting audit:', error)
      throw error
    }
  }
  async deleteAudit(auditId: string): Promise<void> {
    try {
      const response = await del(`/audit/${auditId}`)

      if (!response.ok) {
        await throwApiError(response)
      }
    } catch (error) {
      console.error('Error deleting audit:', error)
      throw error
    }
  }
}

const auditApi = new AuditAPI()

export default auditApi
